import { createElement, useCallback, useContext } from 'react';
import { ProTableFilterContext } from '@/components/table/pro-table/contexts/pro-table-filter-context';
import StringFilter from './string-filter';
import DateRangeFilter from './date-range-filter';
import NumberRangeFilter from './number-range-filter';
import UniqueCodeFilter from './unique-code-filter';
import DictFilter from './dict-filter';
import ApiSelectFilter from './api-select-filter';
import { debounce } from 'lodash-es';
import './index.scss';
const Filter = ({ title, formatType, dataIndex, dict, type }) => {
    const { whereCondition, setWhereCondition, fieldMap } = useContext(ProTableFilterContext);
    const onChange = debounce((value) => {
        setWhereCondition(filterConditions(whereCondition, value));
    }, 500);
    const renderFilter = useCallback((formatType, dataIndex, dict, type) => {
        const fieldName = fieldMap[dataIndex];
        switch (formatType) {
            case 'text':
                return (createElement(StringFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value) }));
            case 'date':
                return (createElement(DateRangeFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value) }));
            case 'number':
                return (createElement(NumberRangeFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value) }));
            case 'money':
                return (createElement(NumberRangeFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value), type: "money" }));
            case 'uniqueCode':
                return (createElement(UniqueCodeFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value), dict: dict }));
            case 'dict':
                return (createElement(DictFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value), dict: dict }));
            case 'api':
                return (createElement(ApiSelectFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value), type: type }));
            default:
                return (createElement(StringFilter, { name: dataIndex, fieldName: fieldName, onChange: (value) => onChange(value) }));
        }
    }, [fieldMap, onChange]);
    return (createElement("div", { className: "title-group" },
        createElement("div", { className: "title" }, title),
        createElement("div", { className: "filter" }, renderFilter(formatType, dataIndex, dict, type))));
};
export default Filter;
export const filterConditions = (conditions = [], currentCondition) => {
    let filteredConditions = [];
    if (Array.isArray(currentCondition)) {
        filteredConditions = conditions
            .filter((item) => currentCondition.every((r) => r.name !== item.name))
            .concat(currentCondition);
    }
    else {
        filteredConditions = conditions
            .filter((item) => item.name !== currentCondition?.name)
            .concat(currentCondition);
    }
    return filteredConditions;
};
